import {
  verifyCoupon
} from "./chunk-2STLQPO2.mjs";

// src/hooks/wbk/coupon/verify.ts
import { useMutation } from "@tanstack/react-query";
var useVerifyCoupon = () => {
  return useMutation({
    mutationFn: verifyCoupon
  });
};

export {
  useVerifyCoupon
};
//# sourceMappingURL=chunk-OMUHQDM4.mjs.map